import React from 'react';
import Image from 'next/image';
import styles from '../styles.module.scss';
import { ASSETS } from 'src/common/utils/config';
import parse from 'html-react-parser';

const Index = ({ carousalItem }) => {
  return (
    <div className={styles.testimonialCard} key={carousalItem?.name}>
      <div className={styles.testimonialCardHead}>
        <div
          className={styles.avatar}
          style={{ backgroundImage: `url(${carousalItem?.avatar_url})` }}
        />
        <div className={styles.customerDetails}>
          <div className={styles.customerName}>{carousalItem?.name}</div>
        </div>
        <Image src={ASSETS.BLUE_TICK} height={'16px'} width={'16px'} />
      </div>
      <div className={styles.customerFeedback}>
        {parse(carousalItem?.feedback)}
      </div>
    </div>
  );
};

export default Index;
